<section class="reference" id="reference">
    <div class="reference__title">
        <h1>References</h1>
    </div>

    <div class="reference__content">

        <div class="reference__content__list">
            <div data-aos="fade-up" data-aos-duration="500" class="reference__content__list__item">
                <p>
                    1. {{references[0]['referenceText']}}
                </p>
                <p>
                    2. {{references[1]['referenceText']}}

                </p>
            </div>
            <div data-aos="fade-up" data-aos-duration="500" class="reference__content__list__item">
                <p>
                    3. {{references[2]['referenceText']}}
                </p>
                <p>
                    4. {{references[3]['referenceText']}}
                </p>
            </div>
            <div data-aos="fade-up" data-aos-duration="500" class="reference__content__list__item">
                <p>
                    5. {{references[4]['referenceText']}}
                    
                </p>
            </div>

        </div>
    </div>
</section>